module.exports = __webpack_public_path__ + "img/title-20211216.bd2d744b.png";